export const fcPlusTgVersion = 'mmt.desktop.rail.default.default.default.rails_fc_tg_together_dweb';
export const irctcEducationPopup = 'mmt.desktop.rail.default.default.default.rails_traveller_irctc_username_edu_popup_Dweb';
export const whyIsThisRequired = 'mmt.desktop.rail.default.default.default.rails_traveller_irctc_edu_witr_Dweb';
export const travellerPageHeader = 'mmt.desktop.rail.default.listing.default.rails_desktop_NewHeader';

export const AB_CONFIG_KEYS = {
  free_cancellation_rails: true,
  railsConfirmationGuaranteeOption: 1,
  rails_travelers_irctc_account_toast: true,
  rails_ayodhya_banner: true,
  'mmt.desktop.rail.default.default.default.rails_fctg_dweb': false,
  'mmt.desktop.rail.default.default.default.rails_fctg_listing': 1,
  [fcPlusTgVersion]: 0,
  [irctcEducationPopup]: 0,
  [whyIsThisRequired]: 0,
  [travellerPageHeader]: false,
};
